import { Component, OnInit, ViewChild } from '@angular/core';
import { AppStorage } from '../../services/appStorage.service';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { MatMenuTrigger, MatDialog, MatDialogRef } from '@angular/material';
import { ModalErrorLoginComponent } from '../modal-error-login/modal-error-login.component';
import { RutPipe } from 'ng2-rut';
import {ENDPOINTS, RECAPTCHA} from '../../constants/app-values';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  constructor(
    public appStorage: AppStorage,
    private loginService: LoginService,
    public router: Router,
    public dialog: MatDialog,
    private _rutPipe: RutPipe,
    private reCaptchaV3Service: ReCaptchaV3Service
  ) {}

  usuario: any;
  pass: any;
  check = false;
  usuarioFormControl = new FormControl('', [Validators.required]);
  passFormControl = new FormControl('', [Validators.required]);
  dialogRef: MatDialogRef<ModalErrorLoginComponent>;
  token_captcha: any;

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  ngOnInit() {
    this.reCaptchaV3Service.execute(RECAPTCHA.SECRET_KEY, 'homepage', (token) => {
      this.token_captcha = token;
    }, {
      useGlobalDomain: false
    });
  }

  validarTexto() {
    if ( this.usuario.indexOf('@') === -1) {
      this.usuario = this._rutPipe.transform(this.usuario);
    }
  }

  login() {
    this.menuTrigger.closeMenu();
    this.appStorage.loadingGeneral = true;

    this.loginService
      .login(this.usuario, this.pass, this.token_captcha)
      .then((res: any) => {
        if (res.body.authorization) {
          this.appStorage.token = res.body.authorization;
          this.getDatosSesion(this.check);
        } else {
          console.log('Error login');
        }
        this.appStorage.loadingGeneral = false;
      })
      .catch(error => {
        if (error.status === 401) {
          this.dialogRef = this.dialog.open(ModalErrorLoginComponent, {
            width: '450px'
          });
        }

        localStorage.removeItem('token');
        this.appStorage.conSesion = false;
        this.appStorage.loadingGeneral = false;
      });
  }

  loginCognito() {

    this.menuTrigger.closeMenu();
    this.appStorage.loadingGeneral = true;

    window.location.href = ENDPOINTS.HOST_COGNITO;
  }

  getDatosSesion(check) {
    this.loginService
      .getDatosSesion()
      .then((res: any) => {
        this.appStorage.datosSesion = {
          usuario: res.usuario,
          // perfil: this.appStorage.perfilesUsuario.EMPRESA_EDITOR
          perfil: res.idperfil
        };
        this.appStorage.conSesion = true;
        this.appStorage.cognitoCoordinador = false;
        this.appStorage.loadingSesion = false;

        if (this.check) {
          localStorage.setItem('token', this.appStorage.token);
        } else {
          sessionStorage.setItem('token', this.appStorage.token);
          localStorage.removeItem('token');
        }

        if (this.router.url === '/' || this.router.url === '/publico/coordinador/logout') {
          this.appStorage.goHome();
        }

        if ((<any>window).PasswordCredential) {
          const c = new (<any>window).PasswordCredential({
            id: this.usuario,
            idName: 'username',
            password: this.pass,
            passwordName: this.appStorage.inputName,
            name: 'IFC'
          });
          return (<any>navigator).credentials.store(c);
        } else {
          console.log('no hay credential');
        }
      })
      .catch(error => {
        this.appStorage.token = undefined;
        this.appStorage.conSesion = false;
        this.appStorage.loadingSesion = false;
      });
  }

  navigate(URL) {
    this.router.navigate([URL]);
    this.menuTrigger.closeMenu();
  }

  cerrarSesion() {
    this.appStorage.datosSesion = undefined;
    this.appStorage.token = undefined;
    this.appStorage.conSesion = false;
    this.appStorage.cognitoCoordinador = false;
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    this.usuario = undefined;
    this.pass = undefined;
    this.usuarioFormControl.reset();
    this.passFormControl.reset();
    this.menuTrigger.closeMenu();
    window.location.href = '/';
  }

  cerrarSesionCognito() {
    this.menuTrigger.closeMenu();
    this.appStorage.loadingGeneral = true;
    this.cerrarSesion();
    window.location.href = ENDPOINTS.HOST_COGNITO_LOGOUT;
  }
}
